module.exports = __webpack_public_path__ + "img/china.00d7b6d9.png";